__turbopack_context__.v({
  "card": "CoreLocationsListingGroups-module-scss-module__s8lTkG__card",
  "group": "CoreLocationsListingGroups-module-scss-module__s8lTkG__group",
  "items": "CoreLocationsListingGroups-module-scss-module__s8lTkG__items",
  "main": "CoreLocationsListingGroups-module-scss-module__s8lTkG__main",
});
